import * as html from 'smg/html';

export interface Options {
    title: string;
    body: string | HTMLElement;
}

export default class Dropup {
    private $backdrop: HTMLElement;
    private $dropup: HTMLElement;
    private $handle: HTMLElement;

    constructor(private opts: Options) {
        this.$backdrop = html.FromString(`
            <div class="dropup-backdrop">
                <div class="dropup">
                    <div class="dropup-handle"></div>

                    <h4 class="dropup-title">${html.Escape(this.opts.title)}</h4>
                </div>
            </div>`);

        this.$dropup = this.$backdrop.querySelector('.dropup') as HTMLElement;
        this.$handle = this.$backdrop.querySelector('.dropup-handle') as HTMLElement;

        this.$backdrop.addEventListener('click', e => {
            if (e.target === this.$backdrop) {
                this.Close();
            }
        });

        this.$dropup.appendChild(this.opts.body instanceof HTMLElement ? this.opts.body : html.FromString(this.opts.body));

        this.Show();

        // enable the drag handle, it moves the dropup on the y axis.
        // on drag we add the "dragging" class to the dropup.
        // Can't drag it higher than it started
        // dragging changes the transform: translate y of the dropup
        let startY: number = 0;
        // let startTop: number = 0;
        let dragging: boolean = false;
        ['mousedown', 'touchstart'].forEach(evt => this.$handle.addEventListener(evt, e => {
            e.preventDefault();

            if (e instanceof MouseEvent) {
                startY = e.clientY;
            } else if (e instanceof TouchEvent) {
                startY = e.touches[0].clientY;
            }
            // startTop = this.$dropup.getBoundingClientRect().top; // this is wrong, it should be the transform: translateY
            dragging = true;
            this.$dropup.classList.add('dragging');

            ['mousemove', 'touchmove'].forEach(evt => window.addEventListener(evt, mouseMove), { passive: false });
            document.body.style.userSelect = 'none';
            document.body.style.setProperty('overflow-behavior', 'none');
            document.body.style.touchAction = 'none';
            this.$dropup.style.overflow = 'hidden';
        }, { passive: false }));

        let dragDistance: number = 0;
        const mouseMove = (e: Event) => {
            if (dragging) {
                e.preventDefault();

                if (e instanceof MouseEvent) {
                    dragDistance = e.clientY - startY;
                } else if (e instanceof TouchEvent) {
                    dragDistance = e.touches[0].clientY - startY;
                } else {
                    return;
                }
                dragDistance = Math.max(0, dragDistance);
                this.$dropup.style.transform = `translateY(${dragDistance}px)`;
            }
        };

        ['mouseup', 'touchend'].forEach(evt => this.$handle.addEventListener(evt, () => {
            dragging = false;
            this.$dropup.classList.remove('dragging');

            window.removeEventListener('mousemove', mouseMove);
            document.body.style.userSelect = '';
            document.body.style.removeProperty('overflow-behavior');
            document.body.style.touchAction = '';
            this.$dropup.style.overflow = '';

            const height = this.$dropup.getBoundingClientRect().height;
            const dragCloseThreshold = Math.max(0.25 * height, 50);
            if (dragDistance > dragCloseThreshold) {
                setTimeout(() => {
                    this.$dropup.style.transform = '';
                    this.Close();
                });
            } else {
                setTimeout(() => this.$dropup.style.transform = '');
            }
        }));
    }

    public Show() {
        document.body.appendChild(this.$backdrop);
        document.body.classList.add('dropup-open');
        setTimeout(() => this.$dropup.classList.add('show'));
    }

    public Close() {
        this.$dropup.classList.remove('show');
        setTimeout(() => {
            document.body.classList.remove('dropup-open');
            this.$backdrop.remove();
        }, 150);
    }
}